// Registers /service-worker.js for offline support + PWA installability.
// Only runs in production builds to avoid clobbering CRA's dev hot-reload.

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;
  // Allow override for testing in dev
  const force = (() => {
    try { return localStorage.getItem('bge_force_sw') === '1'; } catch { return false; }
  })();
  if (process.env.NODE_ENV !== 'production' && !force) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info('[PWA] Service worker registered:', reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[PWA] Service worker registration failed:', err);
      });
  });
};

export const unregisterServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
};
